module.exports = __webpack_public_path__ + "static/Xenios40-7a758e83dc7bda1aa6a47b4bc1bf5f17.jpg";